import { render, staticRenderFns } from "./TimerAndActionSendSmsInAuth.vue?vue&type=template&id=4e64cf66&"
import script from "./TimerAndActionSendSmsInAuth.vue?vue&type=script&lang=js&"
export * from "./TimerAndActionSendSmsInAuth.vue?vue&type=script&lang=js&"
import style0 from "./TimerAndActionSendSmsInAuth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports